/*globals $:false */

import ReportsM from './model/reportm.model.reports.js';
import ReportsP from './presenter/reportm.presenter.reports.js';

var Reports = function(core, moduleBaseUri) {

    var _reportsP,
        $reportsContainer = $("<section class='js-reports taskboard content'></section>");

    var _breadcrumbText;

    return{
        init: function() {
            var model = new ReportsM(core);

            $reportsContainer.appendTo('#'+core.getAppInstanceId());

            _reportsP = new ReportsP(core, moduleBaseUri, $reportsContainer, model);

            _reportsP.init();

            _breadcrumbText = core.translateString("reportm", "reports.title");
        },
        pause:function(){
            _reportsP.pause();
            $reportsContainer.detach();
        },
        resume: function(){
            _reportsP.resume();
            $reportsContainer.appendTo('#'+core.getAppInstanceId());
        },
        destroy:function(){
            _reportsP.destroy();
            $reportsContainer.remove();
        },
        getDescription: function() {
            return _breadcrumbText;
        }
    };
};

export default Reports;
